import gql from 'graphql-tag';
import { ITagInputs, State } from 'app/shared/tags/interfaces/tag';
import { IntellijaBrokerConfig } from 'app/datasources/interfaces/interfaces';
import { Writeback } from 'app/shared/alarms/intefaces/intefaces';
import { IAggregateTags, IGroupAcls } from 'app/assets/interfaces/interfaces';
import { IAggrPayload } from 'app/shared/panels/chart/Models/chart-settings.model';
import { IDropdown } from 'app/shared/interfaces/model';

export interface Label {
  id?: string;
  label: {
    name: string;
    id?: string;
  };
}

export interface ICalTagDetail {
  id: string;
  output_type: string;
  script: any;
  script_input_tags: ITagInputs[];
  script_input_props: ITagInputs[];
  agg_configs: ITagInputs[];
}

export interface TagSummary {
  id?: string;
  name: string;
  tagTypeId: string;
  tagType: string;
  displayName?: string;
  componentName?: string;
  entityId?: string;
  componentInstanceId?: string;
  componentInstanceName?: string;
  assetId?: string;
  assetName?: string;
  showName?: string;
  tagId?: string;
  tagName?: string;
  modelId?: string;
  modelName?: string;
}

export interface TagDetail {
  id?: string;
  entity_id: string;
  entityId?: string;
  name: string;
  dummyName?: string;
  entityType?: string;
  entityName?: string;
  calc_tag_config?: ICalTagDetail;
  disableDeleteAction?: boolean;
  tagTypeId: string;
  tagType: string;
  displayName?: string;
  description: string;
  alarms?: boolean;
  action?: boolean;
  displayEuSymbol?: string;
  historizedId: string;
  displayEuId: string;
  allowWrite: boolean;
  factor: number;
  offset: number;
  precision: number;
  rejectMax: number;
  rejectMin: number;
  histPercentChange: number;
  isThousandSeparator: boolean;
  measurementCategory: number;
  states: State[];
  componentName?: string;
  componentId?: string;
  nodeName?: string;
  dsNodeTagId?: string;
  tagMappinglinkId?: string;
  entityTagId?: string;
  entityDsNodeLinksId?: string;
  effectiveTo?: string;
  effectiveFrom?: string;
  dsNodeId?: string;
  dsNodeTagName?: string;
  dsId?: string;
  dsName?: string;
  dsTypeName?: string;
  dsNodeName?: string;
  dsNodeType?: string;
  tagMappingLinkUomName?: string;
  tagMappingLinkUomId?: number;
  isLinked?: boolean;
  componentInstanceId?: string;
  componentInstanceName?: string;
  alarmsCount?: number;
  dsTagValue?: string;
  dsTagTimestamp?: string;
  dsTagQuality?: string;
  dsTagUom?: string;
  commentCode?: string;
  assetId?: string;
  assetName?: string;
  modelId?: string;
  modelName?: string;
  checked?: boolean;
  type?: string;
  dataType?: string;
}

export interface IAggrTagsDetail {
  id: string;
  name: string;
  tagTypeId: string;
  tagType: string;
  displayName: string;
  showName?: string;
  componentName: string;
  componentInstanceId: string;
  componentInstanceName: string;
  assetName: string;
  assetId: string;
}

export interface TagInterface {
  name: string;
  is_thousand_separator: boolean;
  measurement_category: number;
  allow_write: boolean;
  created_by: string;
  created_date: string;
  description: string;
  display_eu_id: string;
  display_name: string;
  entity_id: string;
  factor: number;
  hist_percent_change: number;
  historized_id: string;
  id: string;
  is_override: boolean;
  offset: number;
  precision: number;
  reject_max: number;
  reject_min: number;
  tag_type_id: string;
  updated_by: string;
  updated_date: string;
  calc_tag_config?: ICalTagDetail;
  state_tags: Array<{
    color: string;
    created_date: string;
    id: string;
    is_blink: boolean;
    state: string;
    tag_id: string;
    value: number;
  }>;
  tag_mapping_links: LinkTagInterface[];
  ref_measurement: {
    id: string;
    name: string;
  };
  ref_tag_type: {
    name: string;
    id: string;
  };
  ref_uom: {
    id: string;
    name: string;
    symbol: string;
  }
  alarms_configs: Array<{
    id: string;
    is_deleted: string;
  }>;
};

export interface ComponentsByEntityId {
  id: string;
  component_id: string;
  model_component_instances: Array<{
    name: string;
    component_instance_id: string;
    model_component_id: string;
    entities_component: {
      component_id: string;
      id: string;
      entity: IModelEntitiesTags;
      entityByEntityId: IModelEntitiesTags;
    }
  }>;
};

export interface IModelEntitiesTags {
  name: string;
  id: string;
  components?: Array<{ component_id: string; notes: string; ref_component_type: { id: string; name: string }; vendor: { id: string; name: string } }>
  properties: PropertiesInterface[];
  tags_aggregate?: {
    aggregate: {
      count: number;
    };
  };
  tags?: TagInterface[];
  alarmsConfigsByComponentId: AlarmsConfigsInterface[];
}

export interface AlarmsConfigsInterface {
  auto_ack: boolean;
  component_id: string;
  condition_type: string;
  created_by: string;
  created_date: string;
  group_name: string;
  id: string;
  is_deleted: boolean
  latch: boolean;
  message: string;
  range_max: number;
  range_min: number;
  re_alarm: boolean;
  recommended_action: string;
  roc_value: number;
  setpoint: number;
  severity: string;
  tag_id: string;
  time: number;
  updated_by: string;
  updated_date: string;
  tag: {
    id: string;
    name: string;
  }
  event_config: {
    name: string;
    description: string;
    event_config_type: string;
    parent_config_id?: string;
    id: string;
    is_deleted: boolean;
    event_actions: Writeback;
    is_enabled: boolean;
    is_override: boolean;
  }
}

export interface IGetAssetSummaryList {
  id: string;
  name: string;
}

export const GetAssetsSummaryList = gql`
    query getAssetsSummaryList {
  intellija_entities(where: {ref_entity_type: {name: {_eq: "asset"}}, is_deleted: {_eq: false}}) {
    id
    name
  }
}`;

// For Assets
export interface GetAssetsListInterface {
  id: string;
  name: string;
  source_model_id: string;
  created_by: string;
  created_date: string;
  updated_by: string;
  updated_date: string;
  is_deleted: string;
  entity: IEntity;
  entity_ds_node_links?: Array<{ ds_node_id }>;
  labels: Label[];
  properties: PropertiesInterface[];
}

export interface IEntity {
  id: string;
  name: string;
  models?: Array<{ ref_model_type: { name } }>;
  properties: PropertiesInterface[];
  entitiesComponentsByEntityId: ComponentsByEntityId[];
  tags?: TagInterface[];
  tags_aggregate?: {
    aggregate: {
      count: number;
    };
  }
  entitiesComponentsByEntityId_aggregate: {
    aggregate: {
      count: number;
    };
  };
}

export const GetAssetsList = gql`
query getAssetsList {
  intellija_entities(where: {ref_entity_type: {name: {_eq: "asset"}}, is_deleted: {_eq: false}}) {
    id
    name
    source_model_id
    entity_type_id
    updated_date
    updated_by
    created_date
    created_by
    is_deleted
    entity_ds_node_links {
      ds_node_id
      # is_linked
    }
    entity {
      id
      name
      models {
        ref_model_type {
          name
        }
      }
      tags_aggregate {
        aggregate {
          count
        }
      }
      entitiesComponentsByEntityId_aggregate {
        aggregate {
          count
        }
      }
      entitiesComponentsByEntityId {
        id
        component_id
        entity_id
        model_component_instances {
          name
          component_instance_id
          model_component_id
          entities_component {
            component_id
            id
            entity {
              id
              name
              tags_aggregate {
                aggregate {
                  count
                }
              }
              alarmsConfigsByComponentId(where: {is_deleted: {_eq: false}}) {
                id
                is_deleted
                event_config {
                  id
                  name
                  parent_config_id
                  is_override
                }
              }
            }
          }
        }
      }
    }
    labels: labels_entities {
      id
      label {
        name
        id
      }
    }
  }
}`;

// For Assets
export interface GetAssetsByIdInterface {
  id: string;
  name: string;
  source_model_id: string;
  created_by: string;
  created_date: string;
  updated_by: string;
  updated_date: string;
  is_deleted: string;
  entity: {
    id: string;
    name: string;
    entitiesComponentsByEntityId: ComponentsByEntityId[];
    entitiesComponentsByEntityId_aggregate: {
      aggregate: {
        count: number;
      };
    };
  };
  labels: Label[];
}

// get asset basic detail by asset id
export const getAssetBasicDetailById = gql`
query getAssetBasicDetailById($assetId: uuid!) {
  intellija_entities(where: {id: {_eq: $assetId}}) {
    id
    name
    source_model_id
    entity_type_id
    updated_date
    updated_by
    created_date
    created_by
    is_deleted
    entity {
      id
      name
      tags_aggregate {
        aggregate {
          count
        }
      }
      entitiesComponentsByEntityId_aggregate {
        aggregate {
          count
        }
      }
      entitiesComponentsByEntityId {
        component_id
        id
        entity_id
        model_component_instances {
          name
          component_instance_id
          model_component_id
          entities_component {
            component_id
            id
            entity {
              name
              id
              tags_aggregate {
                aggregate {
                  count
                }
              }
            }
          }
        }
      }
    }
    labels: labels_entities {
      id
      label {
        name
        id
      }
    }
  }
}`

// get asset tags detail by asset id
export const getAssetTagsDetailById = gql`
query getAssetTagsDetailById($assetId: uuid!) {
  intellija_entities(where: {id: {_eq: $assetId}}) {
    id
    name
    source_model_id
    entity_type_id
    entity {
      id
      name
      tags {
        name
        is_thousand_separator
        measurement_category
        allow_write
        created_by
        created_date
        description
        display_eu_id
        display_name
        entity_id
        factor
        hist_percent_change
        historized_id
        id
        is_override
        offset
        precision
        reject_max
        reject_min
        tag_type_id
        updated_by
        updated_date
        calc_tag_config {
          id
          script
          script_input_tags
          output_type
        }
        state_tags {
          color
          created_date
          id
          is_active
          is_blink
          state
          tag_id
          value
        }
        ref_measurement {
          id
          name
        }
        ref_tag_type {
          name
          id
        }
      }
      entitiesComponentsByEntityId {
        component_id
        id
        entity_id
        model_component_instances {
          name
          component_instance_id
          model_component_id
          entities_component {
            component_id
            id
            entity {
              name
              id
              tags_aggregate {
                aggregate {
                  count
                }
              }
              tags {
                name
                is_thousand_separator
                measurement_category
                allow_write
                created_by
                created_date
                description
                display_eu_id
                display_name
                entity_id
                factor
                hist_percent_change
                historized_id
                id
                is_override
                offset
                precision
                reject_max
                reject_min
                tag_type_id
                updated_by
                updated_date
                calc_tag_config {
                  id
                  script
                  script_input_tags
                  output_type
                }
                state_tags {
                  color
                  created_date
                  id
                  is_active
                  is_blink
                  state
                  tag_id
                  value
                }
                ref_measurement {
                  id
                  name
                }
                ref_tag_type {
                  name
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}`

// old one
export const GetAssetsById = gql`
query getAssetById($assetId: uuid!) {
  intellija_entities(where: {id: {_eq: $assetId}}) {
    id
    name
    source_model_id
    entity_type_id
    updated_date
    updated_by
    created_date
    created_by
    is_deleted
    entity {
      id
      name
      tags {
        name
        is_thousand_separator
        measurement_category
        allow_write
        created_by
        created_date
        description
        display_eu_id
        display_name
        entity_id
        factor
        hist_percent_change
        historized_id
        id
        is_override
        offset
        precision
        reject_max
        reject_min
        tag_type_id
        updated_by
        updated_date
        calc_tag_config {
          id
          script
          script_input_tags
          output_type
        }
        state_tags {
          color
          created_date
          id
          is_active
          is_blink
          state
          tag_id
          value
        }
        ref_measurement {
          id
          name
        }
        tag_mapping_links {
          ds_node_tag_id
          id
          entity_tag_id
          entity_ds_node_links_id
          effective_to
          effective_from
          is_linked
          ds_node_tag {
            ds_node_id
            id
            name
            ds_node {
              ds_id
              id
              name
              type
              datasource {
                id
                name
                type
                ref_datasource_type {
                  id
                  name
                }
              }
            }
          }
        }
        ref_tag_type {
          name
          id
        }
        alarms_configs(where: {is_deleted: {_eq: false}, asset_id: {_is_null: true}}) {
          id
          is_deleted
        }
      }
      entitiesComponentsByEntityId_aggregate {
        aggregate {
          count
        }
      }
      entitiesComponentsByEntityId {
        component_id
        id
        entity_id
        model_component_instances {
          name
          component_instance_id
          model_component_id
          entities_component {
            component_id
            id
            entity {
              name
              id
              tags_aggregate {
                aggregate {
                  count
                }
              }
              tags {
                name
                is_thousand_separator
                measurement_category
                allow_write
                created_by
                created_date
                description
                display_eu_id
                display_name
                entity_id
                factor
                hist_percent_change
                historized_id
                id
                is_override
                offset
                precision
                reject_max
                reject_min
                tag_type_id
                updated_by
                updated_date
                calc_tag_config {
                  id
                  script
                  script_input_tags
                  output_type
                }
                state_tags {
                  color
                  created_date
                  id
                  is_active
                  is_blink
                  state
                  tag_id
                  value
                }
                ref_measurement {
                  id
                  name
                }
                tag_mapping_links {
                  ds_node_tag_id
                  id
                  entity_tag_id
                  entity_ds_node_links_id
                  effective_to
                  effective_from
                  is_linked
                  ds_node_tag {
                    ds_node_id
                    id
                    name
                    ds_node {
                      ds_id
                      id
                      name
                      type
                      datasource {
                        id
                        name
                        type
                        ref_datasource_type {
                          id
                          name
                        }
                      }
                    }
                  }
                }
                ref_tag_type {
                  name
                  id
                }
                alarms_configs(where: {is_deleted: {_eq: false}, asset_id: {_is_null: true}}) {
                  id
                  is_deleted
                }
              }
            }
          }
        }
      }
    }
    labels: labels_entities {
      id
      label {
        name
        id
      }
    }
  }
}`;

// For Assets Ends

// Get Components
export interface GetComponentsListInterface {
  id: number;
  name: any;
  source_model_id: any;
  created_by: any;
  created_date: any;
  updated_by: any;
  updated_date: any;
  is_deleted: string;
  components: Array<{
    component_id: string;
    vendor_id: number;
    notes: string;
    ref_component_type: {
      id: string;
      name: string;
    }
    vendor?: {
      id: number;
      name: string;
    }
  }>;
  entity: {
    name: any;
  };
  labels: {
    id: string;
    label: {
      name: string;
      id: string;
    }
  };
  modelCount: {
    aggregate: {
      count: number;
    }
  };
  entities_components?: Array<{
    entity: {
      name: string;
      id: string;
    }
  }>;
  tags_aggregate: {
    aggregate: {
      count: number;
    }
  };
  image: {
    id: string;
    image: string;
    name: string;
    updated_by: string;
    updated_date: string;
    created_by: string;
    entity_id: string;
    created_date: string;
  }
}

export const GetComponentsList = gql`
    query getComponentsList {
  intellija_entities(where: {ref_entity_type: {name: {_eq: "component"}}, is_deleted: {_eq: false}}) {
    modelCount: entities_components_aggregate {
      aggregate {
        count
      }
    }
    entities_components(where: {entity: {is_deleted: {_eq: false}}}) {
      entity {
        name
        id
      }
    }
    components {
      component_id
      vendor_id
      notes
      ref_component_type {
        id
        name
      }
      vendor{
        id
        name
      }
    }
    id
    name
    source_model_id
    entity_type_id
    updated_date
    created_date
    created_by
    updated_by
    is_deleted
    entity {
      name
      created_date
      id
    }
    labels: labels_entities {
      id
      label {
        name
        id
      }
    }
    tags_aggregate {
      aggregate {
        count
      }
    }
    image {
    id
    image
    name
    }
  }
}
    `;
export interface GetComponentsViewInterface {
  comp_id: string;
  comp_name: string;
  created_by: string;
  created_date: string;
  num_alarms: number;
  num_assets: number;
  num_models: number;
  num_tags: number;
  updated_by: string;
  updated_date: string;
  component_type: string;
  vendor: string;
  labels: ILabels[];
}

export interface ILabels {
  id: string;
  name: string;
  is_active: boolean;
  created_by: string;
  created_date: string;
  updated_by: string;
  updated_date: string;
}

export const GetComponentsView = gql`
query MyQuery {
  intellija_components_view {
    comp_id
    comp_name
    created_by
    created_date
    num_alarms
    num_assets
    num_models
    num_tags
    updated_by
    updated_date
    labels
  }
}`;

export interface GetComponentByIdInterface {
  id: string;
  name: string;
  source_model_id: string;
  created_by: string;
  created_date: string;
  updated_by: string;
  updated_date: string;
  components: Array<{
    component_id: string;
    vendor_id: number;
    notes: string;
    ref_component_types_id: number;
    is_system: boolean;
    has_system_tags: boolean;
  }>;
  entity: {
    name: string;
  };
  image: {
    id: string;
    name: string;
    image: string;
  }
  labels: {
    id: string;
    label: {
      name: string;
      id: string;
    }
  };
  modelCount: {
    aggregate: {
      count: number;
    }
  };
  entities_components?: Array<{
    entity: {
      name: string;
      id: string;
    },
    entityByEntityId: {
      name: string;
      id: string;
    }
  }>;
  tags_aggregate: {
    aggregate: {
      count: number;
    }
  };
  tags?: TagInterface[];
  properties: PropertiesInterface[];
  alarmsConfigsByComponentId: AlarmsConfigsInterface[];
}

export const GetComponentById = gql`
query getComponentById($id: uuid!) {
  intellija_entities(where: {id: {_eq: $id}}) {
    modelCount: entities_components_aggregate {
      aggregate {
        count
      }
    }
    entities_components(where: {entity: {is_deleted: {_eq: false}}}) {
      entityByEntityId {
        name
        id
      }
      entity {
        name
        id
      }
    }
    components {
      component_id
      vendor_id
      notes
      ref_component_types_id
      is_system
      has_system_tags
    }
    id
    name
    source_model_id
    entity_type_id
    updated_date
    created_date
    created_by
    updated_by
    entity {
      name
      created_date
      id
    }
    labels: labels_entities {
      id
      label {
        name
        id
      }
    }
    properties(where: {is_override: {_eq: false}}) {
      name
      id
      updated_by
      updated_date
      value
      entity_id
      created_by
      created_date
      data_type
      ref_property_type {
        name
        id
      }
    }
    image: image {
      id
      image
      name
    }
    tags_aggregate {
      aggregate {
        count
      }
    }
    tags {
      name
      is_thousand_separator
      measurement_category
      allow_write
      created_by
      created_date
      description
      display_eu_id
      display_name
      entity_id
      factor
      hist_percent_change
      historized_id
      id
      is_override
      offset
      precision
      reject_max
      reject_min
      tag_type_id
      updated_by
      updated_date
      ref_uom {
        id
        name
        symbol
      }
      calc_tag_config {
        id
        script
        script_input_tags
        script_input_props
        agg_configs
        is_model_tag
        output_type
      }
      state_tags {
        color
        created_date
        id
        is_active
        is_blink
        state
        tag_id
        value
      }
      ref_tag_type {
        name
        id
      }
      alarms_configs(where: {is_deleted: {_eq: false}, asset_id: {_is_null: true}}) {
        id
        is_deleted
      }
    }
    alarmsConfigsByComponentId(where: {is_deleted: {_eq: false}, asset_id: {_is_null: true}}) {
      auto_ack
      condition_type
      created_by
      created_date
      group_name
      id
      is_deleted
      latch
      message
      range_max
      range_min
      re_alarm
      recommended_action
      roc_value
      setpoint
      severity
      tag_id
      time
      updated_by
      updated_date
      tag {
        id
        name
      }
      event_config {
        name
        description
        event_config_type
        id
        is_deleted
        is_enabled
      }
    }
  }
}
`;

export interface IModels {
  id: string;
  model_id: string;
  ref_model_types_id: number;
  notes?: string;
  has_system_tags: boolean;
}

// Get Models
export interface GetModelsListInterface {
  id: string;
  name: string;
  source_model_id: string;
  created_by: string;
  created_date: string;
  updated_by: string;
  updated_date: string;
  is_deleted: string;
  models?: IModels[];
  entities: Array<{
    id: string;
    name: string;
  }>;
  entitiesComponentsByEntityId_aggregate?: {
    aggregate: {
      count: number;
    }
  };
  labels: Label[];
  entitiesComponentsByEntityId: ComponentsByEntityId[];
  properties: PropertiesInterface[];
}

export const GetModelsList = gql`
  query getModelsList {
  intellija_entities(where: {ref_entity_type: {name: {_eq: "model"}}, is_deleted: {_eq: false}}) {
    id
    name
    source_model_id
    entity_type_id
    created_by
    created_date
    updated_by
    updated_date
    is_deleted
    models {
      ref_model_types_id
    }
    labels: labels_entities {
      id
      label {
        name
        id
      }
    }
    entities(where: {is_deleted: {_eq: false}}) {
      id
      name
    }
    entitiesComponentsByEntityId_aggregate {
      aggregate {
        count
      }
    }
    entitiesComponentsByEntityId {
      id
      component_id
      entity_id
      model_component_instances {
        name
        id
        model_component_id
        entities_component {
          component_id
          id
          entity {
            id
            name
            tags_aggregate {
              aggregate {
                count
              }
            }
            components{
              component_id
              ref_component_type{
                id
                name
              }
            }
            alarmsConfigsByComponentId(where: {is_deleted: {_eq: false}}) {
              id
              is_deleted
            }
          }
        }
      }
    }
  }
}`;

export interface PropertiesInterface {
  name: string;
  id: string;
  updated_by: string;
  updated_date: string;
  value: string;
  entity_id: string;
  created_by: string;
  created_date: string;
  data_type: string;
  is_override: boolean;
  parent_property_id: string;
  entity?: {
    id: string;
    name: string;
  }
  ref_property_type: {
    name: string;
    id: string;
  }
}

// Get Model by ID.
export interface GetModelByIdInterface {
  id: string;
  name: string;
  source_model_id: string;
  created_by: string;
  created_date: string;
  updated_by: string;
  updated_date: string;
  is_deleted: string;
  models?: IModels[];
  components: {
    aggregate: {
      count: number;
    }
  };
  labels: Label[];
  entities: Array<{
    id: string;
    name: string;
  }>;
  entitiesComponentsByEntityId: ComponentsByEntityId[];
  properties: PropertiesInterface[];
}

export const GetModelById = gql`
query getModelById($id: uuid!) {
  intellija_entities(where: {id: {_eq: $id}}) {
    id
    name
    source_model_id
    entity_type_id
    created_by
    created_date
    updated_by
    updated_date
    is_deleted
    models {
      id
      model_id
      ref_model_types_id
      notes
      has_system_tags
    }
    labels: labels_entities {
      id
      label {
        name
        id
      }
    }
    properties(where: {is_override: {_eq: false}}) {
      name
      id
      updated_by
      updated_date
      value
      entity_id
      created_by
      created_date
      data_type
      is_override
      ref_property_type {
        name
        id
      }
    }
    entities(where: {is_deleted: {_eq: false}}) {
      id
      name
    }
    entitiesComponentsByEntityId_aggregate {
      aggregate {
        count
      }
    }
    entitiesComponentsByEntityId {
      id
      component_id
      model_component_instances {
        name
        id
        model_component_id
        component_instance_id
        entities_component {
          component_id
          id
          entity {
            components {
              component_id
              ref_component_type {
                id
                name
              }
              vendor {
                id
                name
              }
              notes
            }
          }
          entityByEntityId {
            name
            id
            properties(where: {is_override: {_eq: false}}) {
              name
              id
              updated_by
              updated_date
              value
              entity_id
              created_by
              created_date
              data_type
              is_override
              ref_property_type {
                name
                id
              }
            }
            tags_aggregate {
              aggregate {
                count
              }
            }
            tags {
              name
              is_thousand_separator
              measurement_category
              allow_write
              created_by
              created_date
              description
              display_eu_id
              display_name
              entity_id
              factor
              hist_percent_change
              historized_id
              id
              is_override
              offset
              precision
              reject_max
              reject_min
              tag_type_id
              updated_by
              updated_date
              calc_tag_config {
                id
                script
                script_input_tags
                script_input_props
                agg_configs
                output_type
              }
              state_tags {
                color
                created_date
                id
                is_active
                is_blink
                state
                tag_id
                value
              }
              ref_tag_type {
                name
                id
              }
              alarms_configs(where: {is_deleted: {_eq: false}, asset_id: {_is_null: true}}) {
                id
                is_deleted
              }
            }
            alarmsConfigsByComponentId(where: {is_deleted: {_eq: false}, _and: {asset_id: {_is_null: true}}}) {
              auto_ack
              component_id
              condition_type
              created_by
              created_date
              group_name
              id
              is_deleted
              latch
              message
              range_max
              range_min
              re_alarm
              recommended_action
              roc_value
              setpoint
              severity
              tag_id
              time
              updated_by
              updated_date
              tag {
                id
                name
              }
              event_config {
                name
                description
                event_config_type
                id
                is_deleted
                is_enabled
              }
            }
          }
          entity {
            name
            id
            properties(where: {is_override: {_eq: false}}) {
              name
              id
              updated_by
              updated_date
              value
              entity_id
              created_by
              created_date
              data_type
              is_override
              ref_property_type {
                name
                id
              }
            }
            tags_aggregate {
              aggregate {
                count
              }
            }
            tags {
              name
              is_thousand_separator
              measurement_category
              allow_write
              created_by
              created_date
              description
              display_eu_id
              display_name
              entity_id
              factor
              hist_percent_change
              historized_id
              id
              is_override
              offset
              precision
              reject_max
              reject_min
              tag_type_id
              updated_by
              updated_date
              ref_uom {
                id
                name
                symbol
              }
              calc_tag_config {
                id
                script
                script_input_tags
                script_input_props
                agg_configs
                output_type
              }
              state_tags {
                color
                created_date
                id
                is_active
                is_blink
                state
                tag_id
                value
              }
              ref_tag_type {
                name
                id
              }
              alarms_configs(where: {is_deleted: {_eq: false}, asset_id: {_is_null: true}}) {
                id
                is_deleted
              }
            }
            alarmsConfigsByComponentId(where: {is_deleted: {_eq: false}, _and: {asset_id: {_is_null: true}}}) {
              auto_ack
              component_id
              condition_type
              created_by
              created_date
              group_name
              id
              is_deleted
              latch
              message
              range_max
              range_min
              re_alarm
              recommended_action
              roc_value
              setpoint
              severity
              tag_id
              time
              updated_by
              updated_date
              tag {
                id
                name
              }
              event_config {
                name
                description
                event_config_type
                id
                is_deleted
                is_enabled
              }
            }
          }
        }
      }
    }
  }
}`;

export const GetModelByIdForDashboards = gql`
query GetModelByIdForDashboards($id: uuid!) {
  intellija_entities(where: {id: {_eq: $id}}) {
    id
    name
    source_model_id
    entity_type_id
    created_by
    created_date
    updated_by
    updated_date
    is_deleted
    models {
      id
      model_id
      ref_model_types_id
      notes
    }
    labels: labels_entities {
      id
      label {
        name
        id
      }
    }
    properties {
      name
      id
      updated_by
      updated_date
      value
      entity_id
      created_by
      created_date
      data_type
      is_override
      parent_property_id
      ref_property_type {
        name
        id
      }
    }
    entities(where: {is_deleted: {_eq: false}}) {
      id
      name
    }
    entitiesComponentsByEntityId_aggregate {
      aggregate {
        count
      }
    }
    entitiesComponentsByEntityId {
      id
      component_id
      model_component_instances {
        name
        id
        model_component_id
        component_instance_id
        entities_component {
          component_id
          id
          entity{
            components{
              component_id
              ref_component_type{
                id
                name
              }
              vendor{
                id
                name
              }
              notes
            }
          }
          entityByEntityId {
            name
            id
            properties {
              name
              id
              updated_by
              updated_date
              value
              entity_id
              created_by
              created_date
              data_type
              is_override
              ref_property_type {
                name
                id
              }
            }
            tags_aggregate {
              aggregate {
                count
              }
            }
            tags {
              name
              is_thousand_separator
              measurement_category
              allow_write
              created_by
              created_date
              description
              display_eu_id
              display_name
              entity_id
              factor
              hist_percent_change
              historized_id
              id
              is_override
              offset
              precision
              reject_max
              reject_min
              tag_type_id
              updated_by
              updated_date
              calc_tag_config {
                id
                script
                script_input_tags
                output_type
              }
              state_tags {
                color
                created_date
                id
                is_active
                is_blink
                state
                tag_id
                value
              }
              ref_tag_type {
                name
                id
              }
              alarms_configs(where: {is_deleted: {_eq: false}, asset_id: {_is_null: true}}) {
                id
                is_deleted
              }
            }
            alarmsConfigsByComponentId(where: {is_deleted: {_eq: false}, _and: {asset_id: {_is_null: true}}}) {
              auto_ack
              component_id
              condition_type
              created_by
              created_date
              group_name
              id
              is_deleted
              latch
              message
              range_max
              range_min
              re_alarm
              recommended_action
              roc_value
              setpoint
              severity
              tag_id
              time
              updated_by
              updated_date
              tag {
                id
                name
              }
              event_config {
                name
                description
                event_config_type
                id
                is_deleted
                is_enabled
              }
            }
          }
          entity {
            name
            id
            properties {
              name
              id
              updated_by
              updated_date
              value
              entity_id
              created_by
              created_date
              data_type
              is_override
              parent_property_id
              ref_property_type {
                name
                id
              }
            }
            tags_aggregate {
              aggregate {
                count
              }
            }
            tags {
              name
              is_thousand_separator
              measurement_category
              allow_write
              created_by
              created_date
              description
              display_eu_id
              display_name
              entity_id
              factor
              hist_percent_change
              historized_id
              id
              is_override
              offset
              precision
              reject_max
              reject_min
              tag_type_id
              updated_by
              updated_date
              ref_uom{
                id
                name
                symbol
              }
              calc_tag_config {
                id
                script
                script_input_tags
                output_type
              }
              state_tags {
                color
                created_date
                id
                is_active
                is_blink
                state
                tag_id
                value
              }
              ref_tag_type {
                name
                id
              }
              alarms_configs(where: {is_deleted: {_eq: false}, asset_id: {_is_null: true}}) {
                id
                is_deleted
              }
            }
            alarmsConfigsByComponentId(where: {is_deleted: {_eq: false}, _and: {asset_id: {_is_null: true}}}) {
              auto_ack
              component_id
              condition_type
              created_by
              created_date
              group_name
              id
              is_deleted
              latch
              message
              range_max
              range_min
              re_alarm
              recommended_action
              roc_value
              setpoint
              severity
              tag_id
              time
              updated_by
              updated_date
              tag {
                id
                name
              }
              event_config {
                name
                description
                event_config_type
                id
                is_deleted
                is_enabled
              }
            }
          }
        }
      }
    }
  }
}
`;

// Get EU Data
export interface GetEudataInterface {
  id: string;
  name: string;
  quantity_type: string;
  catalog_symbol: string;
  created_date: string;
  created_by: string;
  base_unit: string;
  rp66_symbol: string;
  a: any;
  b: any;
  c: any;
  d: any;
}

export const GetEudata = gql`
    query EuData {
  intellija_ref_eu {
    name
    quantity_type
    catalog_symbol
    rp66_symbol
    base_unit
    a
    b
    c
    d
    id
    created_by
    created_date
  }
}

    `;

export interface GetHistorizedInterface {
  id: string;
  name: string;
}

export const GetHistorizedData = gql`
    query historizedData {
  intellija_ref_historized {
    id
    name
  }
}`;

export interface GetPropertyTypesInterface {
  id: string;
  name: string;
}

export const GetPropertyTypes = gql`
  query propertyTypesData {
    intellija_ref_property_types(where: {name: {_neq: "Boolean"}}) {
      id
      name
    }
}`;

export const GetComponentsWithImages = gql`
    query getComponentsWithImages {
      intellija_entities(where: {ref_entity_type: {name: {_eq: "component"}}}) {
        id
        name
        image {
          id
          image
          name
          updated_by
          updated_date
          created_by
          entity_id
          created_date
        }
      }
    }
      `;

//#region Document Queries

export const GetTagsDocument = gql`
query getTags($entity_name: String!) {
  intellija_tags(where: {entity: {name: {_eq: $entity_name}}}) {
    id
    historized_id
    entity_id
    description
    display_name
    display_eu_id
    created_date
    allow_write
    name
    factor
    is_override
    offset
    precision
    reject_max
    reject_min
    tag_type_id
    updated_date
    is_thousand_separator
    hist_percent_change
    measurement_category
    alarms_configs {
      id
      is_deleted
    }
  }
}`;

export const GetTagsByIDDocument = gql`
query getTags($entity_id: uuid!) {
intellija_tags(where: {entity: {id: {_eq: $entity_id}}}) {
    id
    historized_id
    entity_id
    description
    display_name
    display_eu_id
    created_date
    allow_write
    name
    factor
    is_override
    offset
    precision
    reject_max
    reject_min
    tag_type_id
    updated_date
    measurement_category
    hist_percent_change
    is_thousand_separator
    entity{
      id
      name
    }
    calc_tag_config {
      id
      script
      script_input_tags
      output_type
    }
    ref_tag_type {
      name
      id
    }
    state_tags {
      color
      created_date
      id
      is_active
      is_blink
      state
      tag_id
      value
    }
    alarms_configs(where: {is_deleted: {_eq: false}}) {
      id
      is_deleted
    }
  }
}`;

export const GetTagTypesDocument = gql`
query getTagTypes {
  intellija_ref_tag_types(where: {is_active: {_eq: true}}) {
    id
    is_active
    name
  }
}`;

export const GetGroupsDocument = gql`
query getGroups {
intellija_groups {
id
name
}
}`;

export const GetNodesByNameDocument = gql`
query getNodesByName($node_name: String!) {
intellija_groups(where: {nodes: {name: {_like: $node_name}}}) {
id
name
nodes(where: {name: {_like: $node_name}}) {
  id
  name
  node_metrics(where: {name: {_in: ["Online Status"]}}) {
    data_type_id
    name
    value
  }
  devices {
    device_metrics(where: {name: {_in: ["Online Status"]}}) {
      data_type_id
      name
      value
    }
    id
    name
  }
}
}
}`;

export const GetRegNodesListDocument = gql`
query getRegNodesList {
intellija_registered_nodes {
id
name
key
is_linked
created_at
asset_id
registered_group {
  id
  name
}
}
}`;

export const RegistrationMetricsDocument = gql`
query registrationMetrics {
total: intellija_registered_nodes_aggregate {
aggregate {
  count
}
}
linked: intellija_registered_nodes_aggregate(where: {is_linked: {_eq: true}}) {
aggregate {
  count
}
}
registered: intellija_registered_nodes_aggregate(where: {key: {_is_null: false}}) {
aggregate {
  count
}
}
}`;

//#endregion

export interface GetLinkedDatasourceNodesInterface {
  ds_node_id: string;
  effective_from: string;
  effective_to: string;
  entity_id: string;
  id: string;
  is_linked: boolean;
  is_deleted: boolean;
  tag_mapping_links_aggregate: {
    aggregate: {
      count: number;
    };
  }
  ds_node: {
    ds_id: string;
    id: string;
    name: string;
    type: string;
    groupName?: string;
    ref_ds_node_type: {
      id: string;
      name: string;
    }
    datasource: {
      id: string;
      name: string;
      type: string;
      ref_datasource_type: {
        id: string;
        name: string;
      }
    }
  }
}

export const GetLinkedDatasourceNodes = gql`
  query datasourceNodesData($assetId: uuid!) {
    intellija_entity_ds_node_links(where: {entity_id: {_eq: $assetId}, is_deleted: {_eq: false}}) {
      ds_node_id
      effective_from
      effective_to
      entity_id
      id
      is_linked
      is_deleted
      tag_mapping_links{
        id
        entity_ds_node_links_id
        entity_tag_id
        ds_node_tag_id
        is_linked
        component_instance_id
      }
      tag_mapping_links_aggregate(where: {is_linked: {_eq: true}}) {
        aggregate {
          count
        }
      }
      ds_node {
        ds_id
        id
        name
        type
        groupName: config(path: "gn")
        ref_ds_node_type {
          id
          name
        }
        datasource {
          id
          name
          type
          ref_datasource_type {
            id
            name
          }
        }
      }
    }
}`;

export interface DatasourceInterface {
  id: string;
  name: string;
  type: string;
  config: IntellijaBrokerConfig;
  ref_datasource_type: {
    id: string;
    name: string;
  };
}

export const GetDatasources = gql`
  query datasourcesData {
    intellija_datasources {
      id
      name
      type
      config
      ref_datasource_type {
        id
        name
      }
    }
  }`;

export interface DatasourceNodesInterface {
  ds_id: string;
  id: string;
  name: string;
  type: string;
  config?: {
    gn: string;
    nn: string;
  }
  ref_ds_node_type: {
    id: string;
    name: string;
  };
}

export const GetDatasourceNodes = gql`
  query datasourcesData($id: uuid!) {
    intellija_ds_nodes(where: {ds_id: {_eq: $id}}) {
      ds_id
      id
      name
      type
      config
      ref_ds_node_type {
        id
        name
      }
    }
  }`;

export interface LinkTagInterface {
  ds_node_tag_id: string;
  id: string;
  entity_tag_id: string;
  entity_ds_node_links_id: string;
  effective_to: string;
  effective_from: string;
  is_linked: boolean;
  component_instance_id: string;
  entity_ds_node_link: {
    entity_id: string;
  }
  ds_node_tag: {
    ds_node_id: string;
    id: string;
    name: string;
    ds_node: {
      ds_id: string;
      id: string;
      name: string;
      type: string;
      datasource: {
        id: string;
        name: string;
        type: string;
        ref_datasource_type: {
          id: string;
          name: string;
        }
      }
    }
  }
}

export const GetLinkTags = gql`
  query getLinkedTags($assetId: uuid!) {
    intellija_tag_mapping_links(where: {entity_ds_node_link: {is_deleted: {_eq: false}, entity_id: {_eq: $assetId}}}) {
      ds_node_tag_id
      id
      entity_tag_id
      entity_ds_node_links_id
      effective_to
      effective_from
      is_linked
      validated_ds_uom
      component_instance_id
      ref_uom {
        id
        name
      }
      entity_ds_node_link {
        entity_id
      }
      ds_node_tag {
        ds_node_id
        id
        name
        ds_node {
          ds_id
          id
          name
          type
          datasource {
            id
            name
            type
            ref_datasource_type {
              id
              name
            }
          }
        }
      }
    }
  }`;

export interface DsNodeTagInterface {
  ds_node_id: string;
  id: string;
  name: string;
  deviceName: string;
  groupName?: string;
}

export const GetDsNodeTags = gql`
  query getLinkedTags($nodeId: uuid!) {
    intellija_ds_node_tags(where: {ds_node_id: {_eq: $nodeId}}) {
      ds_node_id
      id
      name
      deviceName: config(path: "dn")
      groupName: config(path: "gn")
    }
  }`;

export interface SparkplugDSTypesInterface {
  schema: string;
  id: string;
  name: string;
}

export const GetSparkplugDsTypes = gql`
  query getdatasourceTypes {
    intellija_ref_datasource_types {
      name
      id
      schema
    }
  }`;

export interface GetMeasurmentInterface {
  derived_measurement: string;
  id: number;
  name: string;
  description: string;
  is_system: boolean;
  ref_uoms: {
    base_uom_id: string;
    id: string;
    is_base_uom: string;
    is_system: string;
    symbol: string;
    name: string;
  }
}

export const GetMesururments = gql`
  query getMeasurments {
    intellija_ref_measurements {
      derived_measurement
      description
      id
      name
      is_system
      ref_uoms(where: {is_base_uom: {_eq: true}}) {
        base_uom_id
        id
        is_base_uom
        is_system
        symbol
        name
      }
    }
  }
`;

export interface GetUomsInterface {
  uom_group_id: string;
  id: string;
  name: string;
  measurement_id: number;
  factor: string;
  offset: string;
  symbol: string;
  is_base_uom: boolean;
  base_uom_id: string;
  reference_factor: string;
  reference_offset: string;
  reference_uom_id: string;
  ref_measurement: {
    name: string;
    id: string;
    base_uom: string;
  };
  ref_uom_group: {
    id: number;
    name: string;
  };
}

export const GetUomByMeasurmentId = gql`
  query getUomsByMeasurmentId($id: Int) {
    intellija_ref_uoms(where: {measurement_id: {_eq: $id}}) {
      id
      name
      measurement_id
      uom_group_id
      factor
      offset
      symbol
      base_uom_id
      is_base_uom
      reference_uom_id
      ref_measurement {
        name
        id
      }
      ref_uom_group {
        id
        name
      }
    }
  }
`;

export const GetUoms = gql`
  query getUoms {
    intellija_ref_uoms {
      id
      name
      measurement_id
      uom_group_id
      factor
      offset
      symbol
      base_uom_id
      is_base_uom
      reference_uom_id
      ref_measurement {
        name
        id
      }
      ref_uom_group {
        id
        name
      }
    }
  }
`;

export interface GetUomGroupInterface {
  id: string;
  name: string;
}

export const GetUomGroups = gql`
  query getUomGroups {
    intellija_ref_uom_groups {
      description
      id
      name
    }
  }
`;

export interface RefAlarmSeverityInterface {
  display_name: string;
  is_deleted: boolean;
  name: string;
}

export const RefAlarmSeverity = gql`
  query getAlarmSeverity {
    intellija_ref_alarm_severities {
      display_name
      is_deleted
      name
    }
  }
`;

export interface RefConditionTypesInterface {
  display_name: string;
  is_deleted: boolean;
  name: string;
}

export const RefConditionTypes = gql`
  query getConditionType {
    intellija_ref_condition_types {
      display_name
      is_deleted
      name
    }
  }
`;

export interface GetSubscriptionsInterface {
  asset_id: string;
  browser: boolean;
  component_instance: {
    id: string;
    name: string;
    entities_component: {
      entity: {
        id: string;
        name: string;
      };
    };
  };
  component_instance_id: string;
  email: boolean;
  event_config_id: string;
  event_type: string;
  event_config: {
    id: string;
    name: string;
    is_override: boolean;
    alarms_configs: {
      tag: {
        id: string;
        name: string;
      };
    };
  };
  ref_event_type: {
    name: string;
    display_name: string;
  };
  user_id: string;
  sms: boolean;
  is_deleted: boolean;
  id: string;
}

export const GetSubscriptionFromView = gql`
query subscriptionView($assetId: uuid) {
  intellija_subscriptions_view (where: {asset_id: {_eq: $assetId}}) {
    subscription_id
    alarm_config_id
    alarm_name
    is_override
    event_type
    user_id
    tag_id
    tag_name
    component_id
    component_name
    component_instance_id
    component_alias
    asset_id
    email
    sms
    whatsapp
    browser
    is_deleted
    created_date
    created_by
    updated_date
    updated_by
  }
}
`

export interface GetEventTypeInterface {
  name: string;
  displayName: string;
}

export const GetEventType = gql`
  query getEventType {
    intellija_ref_event_types(where: {is_deleted: {_eq: false}}) {
      name
      displayName: display_name
    }
  }
`;

export interface IPerspectivesUserGroup {
  is_default_perspective: string;
  perspective_id: string;
  user_group_id: string;
};

export interface IPerspectiveTrees {
  id: string;
  entity_id: string;
  latitude: number;
  longitude: number;
  tree_node_type: string;
  name: string;
  node_index: number;
  parent_id: string;
  perspective_id: string;
  aggr_configs?: IPerspectiveAggr[];
  func_config?: { // only use in COUNT function
    countCondition: string;
    value: number | boolean;
    x: number;
    y: number;
  },
  dashboards?: IPerspectiveDashboard[];
  entity: {
    id: string;
    name: string;
  };
};

export interface IPerspectiveDashboard {
  id: string;
  name: string;
  perspective_group_id?: string;
  perspectiveGroupId?: string;
  perspectiveGroupName?: string;
  is_default?: boolean;
  path?: string;
  panels: IPerspectivePanel[];
}

export interface IPerspectivePanel {
  cols: number;
  panelId: string;
  rows: number;
  x: number;
  y: number
}

export interface IPerspectiveAggr {
  id: string;
  name: string;
  function_id: number;
  perspective_group_id: string;
  tags: IAggregateTags[];
  type?: string;
  aggr_configs?: IAggrPayload[];
  func_config?: { // only use in COUNT function
    countCondition: string;
    value: number | boolean;
    x: number;
    y: number;
  },
}

export interface IGetPerspective {
  id: string;
  is_deleted: string;
  isDefault?: boolean;
  name: string;
  display_name: string;
  created_by: string;
  created_date: string;
  updated_by: string;
  updated_date: string;
  perspective_trees: IPerspectiveTrees[];
  perspectives_usergroups: IPerspectivesUserGroup[];
}

export interface IDefaultUsersPerspective {
  intellija_perspectives_users: IDefaultPerspective[]
}

export interface IDefaultPerspective {
  user_name: string;
  perspective_id: string;
}

export interface IDefaultPerspectiveInfo {
  userName: string;
  perspectiveId: string
}

export const GetPerspectives = gql`
  query getPerspectives {
    intellija_perspectives {
      perspective_trees {
        entity_id
        id
        latitude
        longitude
        tree_node_type
      }
      id
      name
      display_name
      created_by
      created_date
      updated_by
      updated_date
      perspectives_usergroups {
        is_default_perspective
        perspective_id
        user_group_id
      }
    }
  }
`;

export const GetPerspectivesById = gql`
  query getPerspectivesById($id: uuid!) {
    intellija_perspectives(where: {id: {_eq: $id}}) {
      perspective_trees {
        entity_id
        id
        name
        latitude
        longitude
        tree_node_type
        node_index
        parent_id
        perspective_id
        dashboards{
          id
          name
          is_default
          path
          perspective_group_id
          panels
        }
        aggr_configs{
          id
          name
          type
          aggr_configs
          function_id
          perspective_group_id
          tags
          func_config
        }
        entity {
          id
          name
        }
      }
      id
      name
      display_name
      created_by
      created_date
      updated_by
      updated_date
      perspectives_usergroups {
        is_default_perspective
        perspective_id
        user_group_id
      }
    }
  }
`;

export interface IAlarmEvents {
  entity: {
    id: string;
    name: string
  };
  component_instance: {
    model_component_instances: {
      name: string;
    }
  }
  acked: {
    status: boolean;
    isAutoAcked: boolean;
    ackedBy: string;
    ackedAt?: string;
    comments?: string;
  };
  shelved: {
    status: boolean;
  };
  latched: {
    status: boolean;
  }
  // updated_by: string;
  // updated_date: string;
  id: string;
  last_trigger_time: string;
  // effective_to: string;
  // effective_from: string;
  // ds_node_tag: {
  //   name: string;
  //   id: string;
  // }
  // created_by: string;
  created_date: string;
  // ds_node_tag_id: string;alarm_config_id
  // component_tag_id: string;
  component_instance_id: string;
  asset_id: string;
  alarm_config_id: string;
  alarm_event_states: {
    alarm_state: string;
    // created_by: string;
    created_date: string;
    details: {
      // numOccurrences?: number;
      originalLivedata?: {
        name?: string;
        id?: number;
        // uuid?: string;
        // eu?: string;
        v?: string;
        // q?: string;
        // t?: string;
        // dataType?: string;
        // backFill?: boolean;
        // dsNodeID?: number;
        // dsNodeUUID?: string;
        // dsNodeName?: string;
      }
    }
    // effective_from: string;
    id: string;
    name: string;
    // effective_to: string;
    process_state: string;
    updated_date: string;
    // updated_by: string;
    // state_id: string;
  };
  event_config: {
    alarms_config: {
      // auto_ack: boolean;
      condition_type: string;
      group_name: string;
      id: string;
      latch: boolean;
      re_alarm: boolean;
      auto_ack: boolean;
      message: string;
      range_max: number;
      range_min: number;
      // re_alarm: boolean;
      recommended_action: string;
      roc_value: number;
      setpoint: number;
      severity: string;
      tag_id: string;
      time: string;
      updated_date: string;
      entity: {
        id: string;
        name: string;
      }
      entityByComponentId: {
        id: string;
        name: string;
      }
      tag: {
        id: string;
        name: string;
      };
      event_config: {
        id: string;
        name: string;
        // event_config_type: string;
        description: string;
        is_enabled: boolean;
        is_override: boolean;
        // event_actions: string;
      }
    }
  }
};

export const GetRealTimeAlarms = gql`
query getAlarmEvents {
  intellija_alarm_events(where: {is_removed: {_eq: false}}) {
    event_config {
      alarms_config {
        component_id
        asset_id
        auto_ack
        re_alarm
        latch
        condition_type
        group_name
        id
        message
        range_max
        range_min
        recommended_action
        roc_value
        setpoint
        severity
        tag_id
        time
        updated_date
        entity {
          id
          name
        }
        entityByComponentId{
          id
          name
        }
        tag {
          id
          name
        }
        event_config {
          id
          name
          is_override
          description
          is_enabled
        }
      }
    }
    entity {
      id
      name
    }
    component_instance {
      model_component_instances {
        name
      }
    }
    acked
    shelved
    latched
    id
    last_trigger_time
    created_date
    component_instance_id
    asset_id
    alarm_config_id
    alarm_event_states(order_by: {created_date: asc}, limit: 1, where: {effective_to: {_is_null: true}}) {
      alarm_state
      created_date
      details
      id
      name
      process_state
      updated_date
      ref_alarm_display_setting {
        alarm
        state_letter
        state
      }
    }
  }
}
`;

export interface IAlarmDisplaySettings {
  alarm: string;
  ack: string;
  blinking: boolean;
  color: string;
  process: string;
  state: string;
  stateLetter: string;
  symbol: string;
}

export const GetAlarmDisplaySettings = gql`
  query getAlarmDisplaySettings {
    intellija_ref_alarm_display_settings {
      alarm
      ack
      blinking
      color
      process
      state
      stateLetter: state_letter
      symbol
    }
  }
`;

// interface for alarms to be rendered in assets section (from the view query)
export interface IAlarmsGrid {
  autoAck: boolean;
  componentId: string;
  componentName?: string;
  componentInstanceId?: string;
  componentInstanceName: string;
  conditionType?: string;
  description?: string;
  eventConfigId?: string;
  eventConfigType?: string;
  parentConfigId?: string;
  groupName: string;
  id: string;
  isDeleted?: boolean;
  isEnabled: boolean;
  isOverride: boolean;
  latch: boolean;
  message?: string;
  name: string;
  rangeMax?: number;
  rangeMin?: number;
  reAlarm: boolean;
  recommendedAction?: string;
  rocValue?: number;
  setpoint: number;
  severity?: string;
  tagId: string;
  tagName?: string;
  time?: number;
}

export const getAggregateFunctions = gql`
  query getAggregateFunctions {
    intellija_ref_agg_functions {
      name
      value: id
      }
    }
`;

export const getChartTypes = gql`
query getChartTypes {
  intellija_ref_chart_types{
    id
    name
  }
}`

export const getComponentSubChartTypes = gql`
query GetSubChartTypes($chartTypeId: Int) {
  intellija_ref_chart_sub_types (where: {chart_type_id: {_eq: $chartTypeId}, is_component:{_eq: true}}){
    id
    name
    thumb_link
  }
}`

export const getModelSubChartTypes = gql`
query GetSubChartTypes($chartTypeId: Int) {
  intellija_ref_chart_sub_types (where: {chart_type_id: {_eq: $chartTypeId}, is_model:{_eq: true}}){
    id
    name
    thumb_link
  }
}`

export const getGroupSubChartTypes = gql`
query GetSubChartTypes($chartTypeId: Int) {
  intellija_ref_chart_sub_types (where: {chart_type_id: {_eq: $chartTypeId}, is_group:{_eq: true}}){
    id
    name
    thumb_link
  }
}`

export const getComponentPanelsByIds = gql`
query getComponentPanelsByIds($ids: [uuid!]) {
  intellija_panels(where: {entity_id: {_in: $ids}}) {
  id
  name
  theme_id
  entity_id
  chart_id
  rows
  cols
  config
  tags
  }
}`

// get perspective group panels by perspective group id
export const getGroupPanelsById = gql`
query getGroupPanelsById($perspectiveGroupId: uuid!) {
  intellija_panels(where: {perspective_group_id: {_eq: $perspectiveGroupId}}) {
    id
    name
    perspective_group_id
    theme_id
    entity_id
    chart_id
    rows
    cols
    config
    agg_configs
    tags
  }
}
`

export const getDashboardsById = gql`
query getDashboardsById($modelId: uuid!) {
  intellija_dashboards(where: {entity_id: {_eq: $modelId}}) {
  id
  name
  path
  is_default
  entity_id
  description
  panels
  created_date
  updated_date
  created_by
  updated_by
  }
}`

// get dashboards by perspective group id
export const getGroupDashboardsById = gql`
query getGroupDashboardsById($perspectiveGroupId: uuid!) {
  intellija_dashboards(where: {perspective_group_id: {_eq: $perspectiveGroupId}}) {
    id
    name
    perspective_group_id
    path
    is_default
    entity_id
    description
    panels
    created_date
    updated_date
    created_by
    updated_by
    }
}`

export const getDashboardPanelsByPanelIds = gql`
query getDashboardPanelsByPanelIds($ids: [uuid!]) {
  intellija_panels(where: {id: {_in: $ids}}) {
  id
  name
  theme_id
  entity_id
  chart_id
  rows
  cols
  config
  tags
  }
}`

export const getModelIdByAssetId = gql`
query getModelIdByAssetId($assetId: uuid!) {
  intellija_entities(where: {id: {_eq: $assetId}}) {
    id
    name
    source_model_id
  }
}`

export const getComponentTypesNVendors = gql`
query getComponentTypesNVendors {
  intellija_ref_component_types{
    id
    name
    # is_system
  }

  intellija_ref_vendors{
    id
    name
    # is_system
  }
}
`

export const getModelTypes = gql`
query getModelTypes {
  intellija_ref_model_types{
    id
    name
    parent_id
    createdOn: created_date
    createdBy: created_by
    updatedOn: updated_date
    updatedBy: updated_by
  }
}`

export const getDSGroups = gql`
query getDSGroups {
  intellija_registered_groups{
    id
    name
    createdOn: created_date
    createdBy: created_by
    updatedOn: updated_date
    updatedBy: updated_by
  }
}`

// get quality codes for the unlinked tags
export const getQualityCodesTagUnlink = gql`
query getQualityCodesTagUnlink {
  intellija_ref_quality_code(where: {type: {_eq: "tag-unlink"}}) {
    code
    name
    description
    createdOn: created_date
    createdBy: created_by
    updatedOn: updated_date
    updatedBy: updated_by
  }
}`

// get quality codes for the unlinked ds node
export const getQualityCodesNodeUnlink = gql`
query getQualityCodesNodeUnlink {
  intellija_ref_quality_code(where: {type: {_eq: "dsnode-unlink"}}) {
    code
    name
    description
    createdOn: created_date
    createdBy: created_by
    updatedOn: updated_date
    updatedBy: updated_by
  }
}`

export const getDefaultPerspectiveByUserName = gql`
query default_Perspective_user($userName: String!) {
  intellija_perspectives_users(where: {user_name: {_eq: $userName}}){
    user_name
    perspective_id
  }
}
`

// for non-admin perspective tree
export const getPerspectivesDetails = gql`
query getPerspectivesDetails($perspectiveIds: [uuid!]) {
  intellija_perspectives(where: {id: {_in: $perspectiveIds}}) {
    id
    name
    display_name
    created_by
    created_date
    updated_by
    updated_date
    perspective_trees {
      entity_id
      id
      latitude
      longitude
      tree_node_type
    }
    perspectives_users {
      perspective_id
      user_name
    }
    perspectives_usergroups {
      is_default_perspective
      perspective_id
      user_group_id
    }
  }
}`;

export const getRefPanelTypes = gql`
query getRefPanelTypes {
  intellija_ref_panel_types{
    id
    name
    display_name
  }
}
`

export interface IGroupTags {
  group_id: string;
  tag_name: string;
  tag_type: string;
}

export const getGroupTags = gql`
query getDistinctGroupTags($perspectiveGroupId: uuid) {
  intellija_distinct_group_tags(where: {group_id: {_eq: $perspectiveGroupId }}) {
    group_id
    tag_name
    tag_type
  }
}`

export interface IGroupTagsInstances {
  asset_id: string;
  asset_name: string;
  group_id: string;
  model_id: string;
  model_name: string;
  component_id: string;
  component_name: string;
  tag_id: string;
  tag_name: string;
  tag_type: string;
  component_instance_name: string;
  component_instance_id: string;
}

export const getGroupTagsInstances = gql`
query getGroupTagsInstances($perspectiveGroupId: uuid, $tagName: String) {
  intellija_group_tag_instances(where: {group_id: {_eq: $perspectiveGroupId}, tag_name: {_eq: $tag_name}}) {
    asset_id
    asset_name
    group_id
    model_id
    model_name
    component_id
    component_name
    tag_id
    tag_name
    tag_type
    component_instance_name
    component_instance_id
  }
}`

export const getGroupTagColNames = gql`
query getGroupTagColNames($perspectiveGroupId: uuid, $tagIds: [uuid!]!, $modelIds: [uuid!]!, $ciIds: [uuid!]!, $cTagIds: [uuid!]!, $cModelIds: [uuid!]!) {
  intellija_group_tag_instances(where: {_or: [{group_id: {_eq: $perspectiveGroupId}, tag_id: {_in: $tagIds}, model_id: {_in: $modelIds}, component_instance_id: {_in: $ciIds}}, {group_id: {_eq: $perspectiveGroupId}, tag_id: {_in: $cTagIds}, model_id: {_in: $cModelIds}}]}) {
    asset_id
    asset_name
    group_id
    model_id
    model_name
    component_id
    component_name
    tag_id
    tag_name
    tag_type
    component_instance_name
    component_instance_id
  }
}
`

export interface IGetGroupsAssetsDetail {
  id: string;
  name: string;
  is_deleted: boolean;
  entity: {
    id: string;
    name: string;
  }
}

export const getGroupsAssetsDetail = gql`
query getGroupsAssetsDetail($assetIds: [uuid!]) {
  intellija_entities(where: {id: {_in: $assetIds}}) {
    id
    name
    is_deleted
    entity {
      id
      name
    }
  }
}`

export interface IGroupProperties {
  group_id: string;
  property_name: string;
  property_type: string;
}

export const getGroupProperties = gql`
query getDistinctProperties($perspectiveGroupId: uuid) {
  intellija_distinct_group_properties(where: {group_id: {_eq: $perspectiveGroupId }}) {
    group_id
    property_name
    property_type
  }
}`

export interface IGroupPropertiesInstances {
  asset_id: string;
  asset_name: string;
  group_id: string;
  model_id: string;
  model_name: string;
  component_id: string;
  component_name: string;
  property_id: string;
  property_name: string;
  property_type: string;
  component_instance_name: string;
  component_instance_id: string;
  is_override?: boolean;
  property_value?: string;
}

export const getGroupPropertiesInstances = gql`
query getGroupPropertiesInstances($perspectiveGroupId: uuid, $propertyName: String) {
  intellija_group_property_instances(where: {group_id: {_eq: $perspectiveGroupId}, property_name: {_eq: $propertyName}}) {
    asset_id
    asset_name
    group_id
    model_id
    model_name
    component_id
    component_name
    property_id
    property_name
    property_type
    component_instance_name
    component_instance_id
    property_value
  }
}`

export const getGroupPropertyColNames = gql`
query getGroupPropertyColNames($perspectiveGroupId: uuid, $propertyIds: [uuid!]!, $modelIds: [uuid!]!, $ciIds: [uuid!]!, $mPropertyIds: [uuid!]!, $mModelIds: [uuid!]!) {
  intellija_group_property_instances(where: {_or: [{group_id: {_eq: $perspectiveGroupId}, property_id: {_in: $propertyIds}, model_id: {_in: $modelIds}, component_instance_id: {_in: $ciIds}}, {group_id: {_eq: $perspectiveGroupId}, property_id: {_in: $mPropertyIds}, model_id: {_in: $mModelIds}}] }) {
    asset_id
    asset_name
    group_id
    model_id
    model_name
    component_id
    component_name
    property_id
    property_name
    property_type
    component_instance_name
    component_instance_id
    property_value
    is_override
  }
}`

export const getCountConditionTypes = gql`
query getCountConditionTypes {
  intellija_ref_count_condition_types(where: {is_deleted: {_eq: false}}) {
    name
    display_name
    is_deleted
  }
}`

export interface IGetUsers {
  id: string;
  username: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  mobile_no: string;
  email: string;
  is_active: boolean;
  customer_id: string;
  created_date: string;
  updated_date: string;
  created_by: string;
  updated_by: string;
}

export const getUsers = gql`
query getusers {
  intellija_users {
    id
    username
    first_name
    middle_name
    last_name
    mobile_no
    email
    is_active
    customer_id
    created_date
    updated_date
    created_by
    updated_by
  }
}`

export const getUser = gql`
query getuser($userId: uuid!) {
  intellija_users(where: {id: {_eq: $userId}}) {
    id
    username
    first_name
    middle_name
    last_name
    mobile_no
    email
    is_active
    customer_id
  }
}`

export interface IGetRolesOrFeature {
  name: string;
  display_name: string;
  features?: string[];
  created_date: string;
  created_by: string;
  updated_by?: string;
  updated_date?: string;
}

export const getRoles = gql`
query getRoles {
  intellija_roles {
    name
    display_name
    features
    created_date
    updated_date
    created_by
    updated_by
  }
}
`

export const getRole = gql`
query getRole($roleName: String!) {
  intellija_roles(where: {name: {_eq: $roleName}}) {
    name
    display_name
    features
  }
}
`

export interface IGetUserGroups {
  id?: string;
  name: string;
  path: string;
  is_deleted?: boolean;
  created_date: string;
  updated_date: string;
  created_by: string;
  updated_by: string;
  realm?: string;
  roles: string[];
  user_group_members?: IUserGroupMembers[]
}

export interface IUserGroupMembers {
  id: string;
  user_id: string;
  user_group_id: string;
  user: {
    id: string;
    username: string;
  }
}

export const getUserGroups = gql`
query getUserGroups {
intellija_user_groups {
  id
  name
  path
  is_deleted
  created_date
  updated_date
  created_by
  updated_by
  realm
  roles
  }
}`

export const getUserGroup = gql`
query getUserGroup($groupId: uuid!) {
  intellija_user_groups(where: {id: {_eq: $groupId}}) {
  id
  name
  path
  realm
  roles
  user_group_members{
    id
    user_id
    user_group_id
    user{
      id
      username
    }
  }
  }
}`

export const getFeatures = gql`
query getFeatures {
  intellija_ref_features {
    name
    display_name
    created_date
    updated_date
    created_by
    updated_by
  }
}
`

export const getFeature = gql`
query getFeature($featureName: String!) {
  intellija_ref_features(where: {name: {_eq: $featureName}}) {
    name
    display_name
    created_date
    updated_date
    created_by
    updated_by
  }
}
`

export const getUserGroupsWithMembers = gql`
query getUserGroupsWithMembers {
  intellija_user_groups {
    id
    name
    path
    realm
    roles
    user_group_members {
      id
      user_id
      user_group_id
      user {
        id
        username
      }
    }
  }
}`

export interface IGetGroupsNAcls {
  intellija_entities: IGetAclsByAssetId;
  intellija_user_groups: IGroupAcls[];
}

export interface IGetAclsByAssetId {
  id: string;
  name: string;
  acls: IACLs
}

export interface IACLs {
  id: string;
  user_group_id: string;
  user_id: string;
  entity_id: string;
  read: boolean;
  write: boolean;
  delete: boolean;
}

export const getUserGroupsNAclsByAssetId = gql`
query getUserGroupsNAclsByAssetId($assetId: uuid!) {
  intellija_user_groups {
    value: id
    name
  }

  intellija_entities(where: {id: {_eq: $assetId}, is_deleted: {_eq: false}}) {
    id
    name
    acls {
      id
      user_group_id
      user_id
      entity_id
      read
      write
      delete
    }
  }
}`

export interface IGetAssetsNAcls {
  intellija_entities: IGroupAcls[];
  intellija_user_groups: IGetAclsByAssetId;
}

// get assets list and acls by user-group id
export const getAssetsNAclsByGroupId = gql`
query getAssetsNAclsByGroupId($userGroupId: uuid!) {
  intellija_entities(where: {ref_entity_type: {name: {_eq: "asset"}}, is_deleted: {_eq: false}}) {
    value: id
    name
    labels: labels_entities {
      label {
        name
      }
    }
  }

  intellija_user_groups(where: {id: {_eq: $userGroupId}, is_deleted: {_eq: false}}) {
    id
    name
    acls {
      id
      user_group_id
      user_id
      entity_id
      read
      write
      delete
    }
  }
}`

export interface IGetFeaturesByRoles {
  intellija_roles: IFeatures[];
}

export interface IFeatures {
  name: string;
  features: string[];
  display_name?: string;
  is_config?: boolean;
}

// get features by roles
export const getFeaturesByRoles = gql`
query getFeaturesByRoles($roles: [String!]) {
  intellija_roles(where: {name: {_in: $roles}}) {
    name
    display_name
    features
  }
}`

// get features detail by features
export const getFeaturesDetailByFeatures = gql`
query getFeaturesDetailByFeatures($features: [String!]) {
  intellija_ref_features(where: {name: {_in: $features}}) {
    name
    is_config
  }
}`

export interface IAssetProps {
  asset_id?: string;
  value?: string;
  component_instance_id?: string;
  data_type?: string;
  entity_id?: string;
  id?: string;
  is_override?: boolean;
  name?: string;
  parent_property_id?: string;
}

// get base properties and override properties by PropertyIds
export const getPropertiesByIds = gql`
query getPropertiesByIds($propertyIds: [uuid!]) {
  intellija_properties(where: {_or: [{id: {_in: $propertyIds}}, {parent_property_id: {_in: $propertyIds}}]}) {
    id
    entity_id
    name
    value
    data_type
    asset_id
    component_instance_id
    is_override
    parent_property_id
  }
}`

// get aggregations time Ranges
export const getTimeAggrRanges = gql`
query getTimeAggrRanges {
  intellija_ref_tag_time_ranges{
    id
    display_name
  }
}`

// get component -> time-aggregations
export const getTimeAggrsByCompId = gql`
query getTimeAggrsByCompId($componentId: uuid) {
  intellija_aggr_configs(where: {type: {_eq: "TIME_AGG"}, entity_id: {_eq: $componentId}}) {
    id
    name
    tags
    func_config
    aggr_configs
    ref_tag_time_range {
      id
      display_name
    }
    ref_agg_type {
      display_name
    }
    ref_agg_function {
      id
      name
    }
    created_by
    created_date
    updated_by
    updated_date
  }
}`

// get model -> time-aggregations (including time-aggr against CIs)
export const getTimeAggrsByModelId = gql`
query getTimeAggrsByModelId($modelId: uuid) {
  intellija_entities(where: {id: {_eq: $modelId}}) {
    id
    name
    aggr_configs {
      id
      name
      tags
      func_config
      aggr_configs
      ref_tag_time_range {
        id
        display_name
      }
      ref_agg_type {
        display_name
      }
      ref_agg_function {
        id
        name
      }
      created_by
      created_date
      updated_by
      updated_date
    }
    entitiesComponentsByEntityId {
      component_id
      model_component_instances {
        component_instance_id
        name
        component_instance {
          entity {
            aggr_configs(where: {type:{_eq: "TIME_AGG"}}) {
              id
              name
              tags
              func_config
              aggr_configs
              ref_tag_time_range {
                id
                display_name
              }
              ref_agg_type {
                display_name
              }
              ref_agg_function {
                id
                name
              }
              created_by
              created_date
              updated_by
              updated_date
            }
          }
        }
      }
    }
  }
}`

export interface ICompTimeAggregations {
  id: string;
  name: string;
  tags: any;
  aggr_configs: any;
  func_config: any;
  created_by: string;
  created_date: string;
  updated_by: string;
  updated_date: string;
  compInstanceId: string;
  ref_tag_time_range: {
    id: string;
    display_name: string;
  };

  ref_agg_type: {
    display_name: string;
  };

  ref_agg_function: {
    id: number;
    name: string;
  };
}

export interface ITagsPropsName {
  name: string;
}

export interface IDsNodeDetail {
  id: string;
  name: string;
  key: string;
  is_linked: boolean;
  groupName?: string;
  linked?: { activated: boolean, icon: string };
  registred?: { activated: boolean, icon: string };
  actions?: { isLinked: boolean, isRegistred: boolean };
  registered_group: { id: number; name: string }
  ds_node: {
    id: string;
    name: string;
    entity_ds_node_links: INodeLinks[]
  }
}

export interface INodeLinks {
  ds_node_id: string;
  effective_from: string;
  effective_to: string;
  entity_id: string;
  is_deleted: boolean;
  is_linked: boolean;
  entity: { id: string; name: string }
}

// get Registered Node Detail for node registration page
export const GetRegisteredNodeDetail = gql`
query getRegisteredNodeDetail {
  intellija_registered_nodes {
    ds_node {
      entity_ds_node_links {
        ds_node_id
        effective_from
        effective_to
        entity_id
        is_deleted
        is_linked
        entity {
          id
          name
        }
      }
      id
      name
    }
    id
    name
    key
    is_linked
    registered_group {
      id
      name
    }
  }
}`

// get distinct tags names
export const getTagsNames = gql`
query getTagsNames {
  intellija_tags(distinct_on: name) {
    name
  }
}`

// get distinct props names
export const getPropertiesNames = gql`
query getPropertiesNames {
  intellija_properties(distinct_on: name) {
    name
  }
}`

export const getComponentTypes = gql`
query getComponentTypes {
  intellija_ref_component_types{
    id
    name
    createdOn: created_date
    createdBy: created_by
    updatedOn: updated_date
    updatedBy: updated_by
    # is_system
  }
}`

export const getVendors = gql`
query getVendors {
  intellija_ref_vendors{
    id
    name
    createdOn: created_date
    createdBy: created_by
    updatedOn: updated_date
    updatedBy: updated_by
    # is_system
  }
}`

export const getAllChartTypesForComponent = gql`
query getAllChartTypesForComponent {
  intellija_ref_chart_sub_types(where: {is_component: {_eq: true}}) {
    name
    value: id
  }
}`

export const getAllChartTypesForModel = gql`
query getAllChartTypesForModel {
  intellija_ref_chart_sub_types(where: {is_model: {_eq: true}}) {
    name
    value: id
  }
}`

export const getAllChartTypesForGroup = gql`
query getAllChartTypesForGroup {
  intellija_ref_chart_sub_types(where: {is_group: {_eq: true}}) {
    name
    value: id
  }
}`

export const getPropertiesByEntityId = gql`
  query getComponentProperties($entityId: uuid!) {
  intellija_properties(where: {entity_id: {_eq: $entityId}, is_override: {_eq: false}}) {
    name
    id
    updated_by
    updated_date
    value
    entity_id
    created_by
    created_date
    data_type
    ref_property_type {
      name
      id
    }
  }
}`

export const getGroupCoordinateProperties = gql`
query getGroupCoordinateProperties($perspectiveGroupId: uuid) {
  intellija_group_property_instances(where: {group_id: {_eq: $perspectiveGroupId}, is_override: {_eq: true}, property_type: {_eq: "Coordinates DD"}}) {
    asset_id
    asset_name
    group_id
    model_id
    model_name
    component_id
    component_name
    property_id
    property_name
    property_type
    component_instance_name
    component_instance_id
    property_value
    is_override
    }
}`

export const getAlarmsByAssetIds = gql`
query getAlarmsByAssetIds($assetIds: [uuid!]) {
  intellija_alarm_events(where: {is_removed: {_eq: false}, asset_id: {_in: $assetIds}}) {
    event_config {
      alarms_config {
        component_id
        asset_id
        auto_ack
        re_alarm
        latch
        condition_type
        group_name
        id
        message
        range_max
        range_min
        recommended_action
        roc_value
        setpoint
        severity
        tag_id
        time
        updated_date
        entity {
          id
          name
        }
        entityByComponentId {
          id
          name
        }
        tag {
          id
          name
        }
        event_config {
          id
          name
          is_override
          description
          is_enabled
        }
      }
    }
    entity {
      id
      name
    }
    component_instance {
      model_component_instances {
        name
      }
    }
    acked
    shelved
    latched
    id
    last_trigger_time
    created_date
    component_instance_id
    asset_id
    alarm_config_id
    alarm_event_states(order_by: {created_date: asc}, limit: 1, where: {effective_to: {_is_null: true}}) {
      alarm_state
      created_date
      details
      id
      name
      process_state
      updated_date
      ref_alarm_display_setting {
        alarm
        state_letter
        state
      }
    }
  }
}
`;